import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { InputLabel } from '@mui/material';
import PropTypes from 'prop-types';
import { ReactComponent as CustomTimePickerIcon } from '../../Assets/images/svg/Clock.svg';
import './timePicker.scss';

const CommonTimePicker = ({
  label,
  value,
  onChange,
  error = false,
  helperText = '',
  placeHolder = '',
  isDisabled = false,
}) => {
  return (
    <div className="custom-time-picker">
      <InputLabel className="timepicker-input-label">{label}</InputLabel>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={['TimePicker']}>
          <TimePicker
            views={['hours', 'minutes']}
            inputFormat="hh:mm a"
            ampm={true}
            thresholdToRenderTimeInASingleColumn={100}
            timeSteps={{ minutes: 15 }}
            value={value}
            onChange={onChange}
            disabled={isDisabled}
            slots={{ openPickerIcon: CustomTimePickerIcon }}
            slotProps={{
              textField: {
                error: error,
                helperText: helperText,
                placeholder: placeHolder,
              },
            }}
            sx={{
              width: '100%',
              '& .MuiInputBase-root': {
                backgroundColor: isDisabled ? '#f5f5f5' : '',
              },
              '& .MuiInputBase-input': {
                fontSize: 'small',
                padding: '1vh 2vh',
                '&::placeholder': {
                  color: 'grey',
                  fontSize: 'small',
                },
              },
            }}
          />
        </DemoContainer>
      </LocalizationProvider>
    </div>
  );
};

CommonTimePicker.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  placeHolder: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default CommonTimePicker;
